import React from 'react'
import { PaginationWrapper } from './Pagination.styled'
import ReactPaginate from 'react-paginate'
import { PaginationPrevious } from '../../assets/icons/PaginationPrevious'
import { PaginationNext } from '../../assets/icons/PaginationNext'
import { useTheme } from 'styled-components'

// Helper to render arrow with correct color based on className
const ArrowIcon = ({ Component }: { Component: React.FC<{ color?: string }> }) => {
  const theme = useTheme()
  // TODO: Properly type theme to include iconsColor and colorGray
  const t = theme as any
  const color = t.iconsColor || t.colorGray
  return <Component color={color} />
}

export const Pagination = ({ pageCount, setPage, forcePage, small }: TPagination) => {
  if (pageCount < 2) return <></>
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //  @ts-ignore
    <PaginationWrapper style={small ? { scale: '0.7' } : {}} >
      <ReactPaginate
        onPageChange={({ selected }) => setPage(selected + 1)}
        previousLabel={<ArrowIcon Component={PaginationPrevious} />}
        nextLabel={<ArrowIcon Component={PaginationNext} />}
        pageCount={pageCount || 4}
        containerClassName='pagination'
        pageClassName='page-item'
        pageLinkClassName='page-link'
        previousClassName='arrow-page'
        previousLinkClassName='page-link'
        nextClassName='arrow-page'
        nextLinkClassName='page-link'
        activeClassName='page-item-active'
        activeLinkClassName='page-link-active'
        breakLabel={false}
        forcePage={forcePage}
        disabledClassName='disabled'
        disabledLinkClassName='disabled'
        renderOnZeroPageCount={null}
      ></ReactPaginate>
    </PaginationWrapper>
  )
}

interface TPagination {
  pageCount: number
  setPage: (n: number) => any
  forcePage: number
  small?: boolean
}
